// eslint-disable-next-line
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card, Typography, Button, Modal, Tabs } from "antd";
import "./styles/clients.css";
import TabPane from "antd/es/tabs/TabPane";
import moment from "moment";
import MyTable from "../components/table";
import { getSiteVisiteDetails } from "../Actions/siteVisitDetailsAction";
import { getAllLeadNotes } from "../Actions/leadNotesAction";
const { Text, Title } = Typography;

export const ViewLead = ({ id, setPopoverVisible, disabled = false, open: externalOpen, onClose: externalOnClose }) => {
  const dispatch = useDispatch();
  const { leads } = useSelector((state) => state.leads);
  const { leadNotes, isGetLeadNotesLoading } = useSelector(
    (state) => state.leadNotes
  );
  const { siteVisitDetails, isGetSiteVisitDetailsLoading } = useSelector(
    (state) => state.siteVisitDetails
  );

  useEffect(() => {
    if (id) {
      dispatch(getSiteVisiteDetails(id));
      dispatch(getAllLeadNotes(id));
    }
  }, [id, dispatch]);

  const [internalOpen, setInternalOpen] = useState(false);
  const isControlled = externalOpen !== undefined;
  const open = isControlled ? externalOpen : internalOpen;

  const handleClose = () => {
    if (externalOnClose) {
      externalOnClose();
    }
    setInternalOpen(false);
  };

  const the_lead = leads.filter((lead) => lead.id === id);
  if (!leads.find((lead) => lead.id === id)) {
    return null;
  }

  const defaultValues = the_lead[0];
  const {
    client,
    max_budget,
    min_budget,
    area,
    areas_of_lead,
    is_lead,
    deal_for,
    home_loan,
    construction_after,
    vastu_complient,
    bhk,
    lead_type,
    types_of_lead,
    facing,
    details,
    is_residential,
    is_commercial,
    is_plot,
    lead_furniture_attributes,
    lead_amenity_attributes,
    lead_nearby_attributes,
    lead_area_attributes,
    lead_status,
  } = defaultValues;
  const {
    fix_drawing_room,
    mod_drawing_room,
    fix_bedroom,
    mod_bedroom,
    fix_kitchen,
    mod_kitchen,
    air_condition,
  } = lead_furniture_attributes;
  const {
    water_24hr,
    png,
    security,
    cctv,
    lift,
    common_parking,
    paid_parking,
    garden,
    children_play_area,
    club_house,
    gymnasium,
    common_plot,
  } = lead_amenity_attributes;
  const {
    religious_place,
    park_garden,
    educational_institute,
    hospital_dispansary,
    mall_market,
    bus_stop,
  } = lead_nearby_attributes;
  const { minimum_sqFt, maximum_sqFt } = lead_area_attributes;

  const statusColors = {
    Hot: "#E63946",
    Warm: "#F4A261",
    Cold: "#3396D3",
    Dead: "#6C757D",
    Success: "#5CB338",
  };

  const handleViewLead = () => {
    setPopoverVisible && setPopoverVisible(false);
    setInternalOpen(true);
  };
  const getLastElementofArray = (arr) => {
    const lengthOfArray = arr.length;
    const lastElement = arr[lengthOfArray - 1];
    return lastElement;
  };

  const NotesColumns = () => [
    {
      title: "Note",
      dataIndex: "text",
      key: "note",
      width: 150,
      render: (text) => (
        <Typography className="notesTableText">{text}</Typography>
      ),
    },
    {
      title: "Via",
      dataIndex: "contact_via",
      key: "contact_via",
      width: 90,
      render: (contact_via) => (
        <Typography className="notesTableText">{contact_via}</Typography>
      ),
    },
    {
      title: "Created by",
      dataIndex: "user",
      key: "user",
      width: 120,
      render: (user) => {
        if (!user) return "-";
        const fullName = `${user.first_name || ""} ${user.last_name || ""}`.trim();
        return (
          <Typography className="notesTableText">
            {fullName || user.name || "-"}
          </Typography>
        );
      },
    },
    {
      title: "Created date",
      dataIndex: "created_at",
      key: "created_at",
      width: 150,
      render: (created_at) => {
        if (!created_at) return "-";
        const formattedDate = moment(created_at, [
          "YYYY-MM-DD",
          "DD/MM/YYYY",
          "MM/DD/YYYY",
          "YYYY-MM-DDTHH:mm:ss.SSSZ",
          "x",
          "X",
        ]).format("DD/MM/YYYY, h:mm a");
        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
    },
  ];

  const SiteVisitColumns = () => [
    {
      title: "Visit time",
      dataIndex: "visit_time",
      key: "visit_time",
      width: 100,
      render: (visit_time) => {
        if (!visit_time) return "-";
        const formattedTime = moment(visit_time).format("HH:mm"); // show 14:00
        return <div>{formattedTime}</div>;
      },
    },
    {
      title: "Visit date",
      dataIndex: "visit_date",
      key: "visit_date",
      width: 100,
      render: (visit_date) => {
        if (!visit_date) return "-";
        const formattedDate = moment(visit_date)
          .utcOffset(330)
          .format("DD/MM/YYYY");
        return (
          <div>{formattedDate !== "Invalid date" ? formattedDate : "-"}</div>
        );
      },
    },
    {
      title: "Note",
      dataIndex: "note",
      key: "note",
      width: 150,
      render: (note) => (
        <Typography className="notesTableText">{note}</Typography>
      ),
    },
  ];

  return (
    <>
      <Button
        type="link"
        style={{ cursor: disabled ? "not-allowed" : "pointer" }}
        onClick={() => handleViewLead()}
        disabled={disabled}
      >
        ViewLead{" "}
      </Button>
      <Modal
        open={open}
        onCancel={() => handleClose()}
        footer={null}
        width={600}
      >
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={<span className="leadTab">View Lead Details</span>}
            key="1"
          >
            <Row gutter={[0, 15]}>
              <Col span={24}>
                <Typography className="viewProjectHeading">
                  Client Information
                </Typography>
                <Row gutter={[0, 8]} className="viewProjectRow">
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Client:{" "}
                      <span className="viewLeadText">{client?.name}</span>
                    </Typography>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Budget:{" "}
                      <span className="viewLeadText">
                        {`₹ ${min_budget}`.replace(
                          /\B(?=(\d{3})+(?!\d))/g,
                          ","
                        )}{" "}
                        -{" "}
                        {`${max_budget}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </span>
                    </Typography>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Lead Status:{" "}
                      <span
                          className="viewLeadText"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              display: "inline-block",
                              width: 8,
                              height: 8,
                              borderRadius: "50%",
                              backgroundColor:
                                statusColors[
                                 lead_status || "#000"
                                ],
                              marginRight: 6,
                            }}
                          ></span>
                          {
                           lead_status || '-'
                          }
                        </span>
                    </Typography>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Details:{" "}
                      <span className="viewLeadText">
                        {details
                          ? details.split("\n").map((line, index) => (
                              <React.Fragment key={index}>
                                {line}
                                <br />
                              </React.Fragment>
                            ))
                          : ""}
                      </span>
                    </Typography>
                  </Col>
                </Row>
              </Col>

              <Col span={24}>
                <Typography className="viewProjectHeading">
                  Property Details
                </Typography>
                <Row gutter={[0, 8]} className="viewProjectRow">
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Constuction After:{" "}
                      <span className="viewLeadText">
                        {construction_after || "-"}
                      </span>
                    </Typography>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Areas:{" "}
                      <span className="viewLeadText">
                        {areas_of_lead?.map(
                          (area) =>
                            area?.area_name +
                            `${
                              getLastElementofArray(areas_of_lead)
                                ?.area_name === area?.area_name
                                ? ""
                                : ", "
                            }`
                        )}
                      </span>
                    </Typography>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Lead Type:{" "}
                      <span className="viewLeadText">
                        {types_of_lead?.types?.map(
                          (type) =>
                            type +
                            `${
                              getLastElementofArray(types_of_lead?.types) ===
                              type
                                ? ""
                                : ", "
                            }`
                        )}
                      </span>
                    </Typography>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Vastu Complient:{" "}
                      <span className="viewLeadText">
                        {vastu_complient === 0 ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Facing:{" "}
                      <span className="viewLeadText">{facing || "-"}</span>
                    </Typography>
                  </Col>
                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Is Residential/Commercial/Plot?:{" "}
                      <span className="viewLeadText">{is_lead || "-"}</span>
                    </Typography>
                  </Col>

                  <Col xs={24} sm={12}>
                    <Typography className="viewLeadTitle">
                      Is New/Resell/Rent/Lease?:{" "}
                      <span className="viewLeadText">{deal_for || "-"}</span>
                    </Typography>
                  </Col>
                </Row>
              </Col>

              <Col span={24}>
                <Typography className="viewProjectHeading">
                  Property Size
                </Typography>
                <Row gutter={[0, 8]} className="viewProjectRow">
                <Col xs={24} sm={12} >
                  <Typography className="viewLeadTitle">
                    Minimum SqFt:{" "}
                    <span className="viewLeadText">{minimum_sqFt || '-'}</span>
                  </Typography>
                </Col>
                <Col xs={24} sm={12} >
                  <Typography className="viewLeadTitle">
                    Maximum SqFt:{" "}
                    <span className="viewLeadText">{maximum_sqFt || '-'}</span>
                  </Typography>
                </Col>
                
                </Row>
              </Col>

              <Col
                span={12}
                style={{ display: is_residential === true ? "block" : "none" }}
              >
                <Typography className="viewProjectTitle">
                  Home Load?{" "}
                  <span className="viewProjectText">{home_loan}</span>
                </Typography>
              </Col>

              <Col
                span={24}
                style={{ display: is_residential === true ? "block" : "none" }}
              >
                <Typography className="viewProjectTitle">
                  BHK: <span className="viewProjectText">{bhk}</span>
                </Typography>
              </Col>

              <Col
                span={24}
                style={{
                  display:
                    is_residential === true || is_commercial === true
                      ? "block"
                      : "none",
                }}
              >
                <Typography className="viewProjectTitle">Furniture</Typography>
              </Col>
              <Col span={24}>
                <Row
                  gutter={[0, 15]}
                  style={{
                    display:
                      is_residential === true || is_commercial === true
                        ? "block"
                        : "none",
                  }}
                >
                  <Col
                    span={24}
                    style={{
                      display: is_residential === true ? "block" : "none",
                    }}
                  >
                    <Typography className="viewProjectTitle">
                      Fix Drawing Room?{" "}
                      <span className="viewProjectText">
                        {fix_drawing_room === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col
                    xl={8}
                    lg={8}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{
                      display: is_residential === true ? "block" : "none",
                    }}
                  >
                    <Typography className="viewProjectTitle">
                      Modular Drawing Room?{" "}
                      <span className="viewProjectText">
                        {mod_drawing_room === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col
                    xl={8}
                    lg={8}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{
                      display: is_residential === true ? "block" : "none",
                    }}
                  >
                    <Typography className="viewProjectTitle">
                      Fix Bedroom?{" "}
                      <span className="viewProjectText">
                        {fix_bedroom === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col
                    xl={8}
                    lg={8}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{
                      display: is_residential === true ? "block" : "none",
                    }}
                  >
                    <Typography className="viewProjectTitle">
                      Modular Bedroom?{" "}
                      <span className="viewProjectText">
                        {mod_bedroom === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col
                    xl={8}
                    lg={8}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{
                      display: is_residential === true ? "block" : "none",
                    }}
                  >
                    <Typography className="viewProjectTitle">
                      Fix Kitchen?{" "}
                      <span className="viewProjectText">
                        {fix_kitchen === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col
                    xl={8}
                    lg={8}
                    md={24}
                    sm={24}
                    xs={24}
                    style={{
                      display: is_residential === true ? "block" : "none",
                    }}
                  >
                    <Typography className="viewProjectTitle">
                      Modular Kitchen?{" "}
                      <span className="viewProjectText">
                        {mod_kitchen === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Air Condition?{" "}
                      <span className="viewProjectText">
                        {air_condition === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                </Row>
              </Col>
              <Col
                span={24}
                style={{
                  display:
                    is_residential === true || is_commercial === true
                      ? "block"
                      : "none",
                }}
              >
                <Typography className="viewProjectTitle">Amenity</Typography>
              </Col>

              <Col span={24}>
                <Row
                  gutter={[0, 15]}
                  style={{
                    display:
                      is_residential === true || is_commercial === true
                        ? "block"
                        : "none",
                  }}
                >
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Water 24hr?{" "}
                      <span className="viewProjectText">
                        {water_24hr === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Png?{" "}
                      <span className="viewProjectText">
                        {png === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Security?{" "}
                      <span className="viewProjectText">
                        {security === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Cctv?{" "}
                      <span className="viewProjectText">
                        {cctv === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Lift?{" "}
                      <span className="viewProjectText">
                        {lift === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Common Parking?{" "}
                      <span className="viewProjectText">
                        {common_parking === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Paid Parking?{" "}
                      <span className="viewProjectText">
                        {paid_parking === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Garden?{" "}
                      <span className="viewProjectText">
                        {garden === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Children Play Area?{" "}
                      <span className="viewProjectText">
                        {children_play_area === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Club House?{" "}
                      <span className="viewProjectText">
                        {club_house === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Gymnasium?{" "}
                      <span className="viewProjectText">
                        {gymnasium === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                  <Col span={24}>
                    <Typography className="viewProjectTitle">
                      Common Plot?{" "}
                      <span className="viewProjectText">
                        {common_plot === true ? "Yes" : "No"}
                      </span>
                    </Typography>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Col span={24}>
              <Row
                style={{
                  display:
                    is_residential === true || is_commercial === true
                      ? "block"
                      : "none",
                }}
                gutter={[0, 15]}
              >
                <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                  <Typography className="viewProjectTitle">Nearby</Typography>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row
                gutter={[0, 15]}
                style={{
                  display:
                    is_residential === true || is_commercial === true
                      ? "block"
                      : "none",
                }}
              >
                <Col span={24}>
                  <Typography className="viewProjectTitle">
                    Religious Place?{" "}
                    <span className="viewProjectText">
                      {religious_place === true ? "Yes" : "No"}
                    </span>
                  </Typography>
                </Col>
                <Col span={24}>
                  <Typography className="viewProjectTitle">
                    Park/Garden?{" "}
                    <span className="viewProjectText">
                      {park_garden === true ? "Yes" : "No"}
                    </span>
                  </Typography>
                </Col>
                <Col span={24}>
                  <Typography className="viewProjectTitle">
                    Educational/Institute?{" "}
                    <span className="viewProjectText">
                      {educational_institute === true ? "Yes" : "No"}
                    </span>
                  </Typography>
                </Col>
                <Col span={24}>
                  <Typography className="viewProjectTitle">
                    Hospital/Dispansary?{" "}
                    <span className="viewProjectText">
                      {hospital_dispansary === true ? "Yes" : "No"}
                    </span>
                  </Typography>
                </Col>
                <Col span={24}>
                  <Typography className="viewProjectTitle">
                    Mall/market?{" "}
                    <span className="viewProjectText">
                      {mall_market === true ? "Yes" : "No"}
                    </span>
                  </Typography>
                </Col>
                <Col span={24}>
                  <Typography className="viewProjectTitle">
                    Bus Stop?{" "}
                    <span className="viewProjectText">
                      {bus_stop === true ? "Yes" : "No"}
                    </span>
                  </Typography>
                </Col>
              </Row>
            </Col>
          </TabPane>
          <TabPane tab={<span className="leadTab">Notes Details</span>} key="2">
            <div style={{ height: "300px", overflowY: "auto" }}>
              <MyTable columns={NotesColumns()} data={Array.isArray(leadNotes) ? leadNotes : leadNotes?.lead_notes || []} />
            </div>
          </TabPane>

          <TabPane
            tab={<span className="leadTab">Site Visit Details</span>}
            key="3"
          >
            <div style={{ height: "200px", overflowY: "auto" }}>
              <MyTable
                columns={SiteVisitColumns()}
                data={Array.isArray(siteVisitDetails) ? siteVisitDetails : siteVisitDetails?.site_visit_details || []}
              />
            </div>
          </TabPane>
        </Tabs>
      </Modal>
    </>
  );
};
